import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { InsidePreview } from './components/InsidePreview';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { PackSection } from './components/PackSection';
import { PricingSection } from './components/PricingSection';
import { ClosingSection } from './components/ClosingSection';
import { FaqSection } from './components/FaqSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2wjqft2hhpwkj">
      <OfferBar data-id="element-1" data-mp="28ufmg62gz4gf" />
      <main data-id="element-2" data-mp="28tw3qn4zwc1c">
        <Hero data-id="element-3" data-mp="28te21azkd5m1" />
        <PainSection data-id="element-4" data-mp="28t4jg8gum0qd" />
        <InsidePreview data-id="element-5" data-mp="28sbbx5a2f776" />
        <ProductSection data-id="element-6" data-mp="23vcmh01cjofb" />
        <BonusSection data-id="element-7" data-mp="23w4ey1znd61d" />
        <PackSection data-id="element-8" data-mp="23utcq6luo6cd" />
        <PricingSection data-id="element-9" data-mp="23t8g8bfz6dbv" />
        <ClosingSection data-id="element-10" data-mp="3ik7g4ghnibqn" />
        <FaqSection data-id="element-11" data-mp="3ikqwhsrnks2k" />
      </main>
      <SiteFooter data-id="element-12" data-mp="3ijpd910hgz9r" />
      <PurchasePopup data-id="element-13" data-mp="3ii4r9zs8ioni" />
    </div>;
}